


































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { alarmsService } from "../services";
import moment from "moment";

@Component({
  name: "Plant Alarms",
})
export default class PlantAlarms extends Vue {
  @Prop() public Plant_ID_for_alarm: any;
  constructor() {
    super();
  }

  public alarmsList = [];
  isActive = true;
  hasError = true;
  activeAlarms: boolean = true;

  mounted() {
    if (this.Plant_ID_for_alarm != null) {
      // alert(this.Plant_ID_for_alarm);
      alarmsService
        .getPlantAlarms(this.Plant_ID_for_alarm)
        .then((response: any) => {
          let data = response.data.alarms_list;
          this.alarmsList = data;
        });
    } else {
      this.active("", "");
      // this.filtered();
    }
  }

  // getAllAlarms() {
  //   alarmsService.getAllAlarms().then((response: any) => {
  //     // console.log(response.data.alarms_list);
  //     let data = response.data.alarms_list;
  //     this.alarmsList = data;
  //   });
  // }
  active(param?, filter?) {
    // console.log(param + " - " + filter);
    alarmsService.getAllAlarms(param, filter).then((response: any) => {
      let data = response.data.alarms_list;
      this.alarmsList = data;
    });
    if (filter == 1) {
      this.activeAlarms = false;
    } else {
      this.activeAlarms = true;
    }
  }
  dateConvert(item) {
    let dateTime = moment.unix(item).format("hh:mm a, MM/DD/YYYY");
    return dateTime;
  }
  check(id) {
    alarmsService.checkStatus(id).then((response) => {
      // alert(JSON.stringify(response))
      if (response) {
        this.$toasted.global.throw({
          message: "Successfull",
        });
        if (this.Plant_ID_for_alarm) {
          // alert("plant hit");
          this.active(this.Plant_ID_for_alarm, 0);
        } else {
          // alert("simple hit");
          this.active("", "");
        }
      }
    });
  }
}
